module.exports = __webpack_public_path__ + "static/hallenstadion-gastro-bda542649ab777fb72a3e32fdae777a5.png";